const translations = {
  "en": {
    "Maybe Later": "Maybe Later",
    "Offer a Suggestion": "Offer a Suggestion",
    "Rate Us on App Store": "Rate Us on App Store",
    "Send Feedback": "Send Feedback"
  },
  "zh-tw": {
    "Maybe Later": "暫不",
    "Offer a Suggestion": "提出建議",
    "Rate Us on App Store": "在 App Store 給我們評分",
    "Send Feedback": "傳送意見回饋"
  }
};

export default translations;
